// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ClientUnprocessableEntityErrorSchema = z.object({
  errors: z.object({}).describe("Error details"),
  suggested_name: z.optional(z.coerce.string().describe("A collision-free name suggestion (e.g. \"Acme (2)\") returned only when the submitted name was rejected as already taken.")),
});
